export function validateOptionalEditorText(
  label: string,
  value: string,
  maxLength: number,
  errors: string[],
): void {
  if (value.length > maxLength) errors.push(`${label} must be ${maxLength} characters or fewer.`);
}
